import * as React from 'react';
import { closeViewFromSeatModal, openViewFromSeatModal } from '../../../actions/app-actions';
import { IAltText } from '../../../classes/alt-text';
import DataLoader from '../../../common/loader/data-loader';


export interface ISeatInfoImageProps {
    seatViewImageSrc: string;
    altText: IAltText;
    loadingSvgText: string;
    loadingText: string;
    stopLoadingAnimationButtonText: string;
    viewFromSeatModalActive: boolean;
    loadingSeatView: boolean;
    dispatch: any;
    seatViewCaptionText: string;
}

interface ISeatInfoImageState {
    phonePanned: boolean,
    seatViewTransform: number,
    currentGamma: number

}

class SeatInfoImage extends React.Component<ISeatInfoImageProps, ISeatInfoImageState> {
    seatViewImg: any;
    seatViewImgLarge: any;

    constructor(props) {
        super(props);

        this.state = {
            phonePanned: false,
            seatViewTransform: -50,
            currentGamma: 0,
        };

        //window.addEventListener("deviceorientation",
        //    this._handleMotion.bind(this)
        //    , true);

    }

    render() {

        const useTagPlus = `<use xlink:href="#icon-search-plus" />`;
        const useTagMinus = '<use xlink:href="#icon-search-minus" />';
        const useTagClose = '<use xlink:href="#icon-close" />';

        if (this.props.seatViewImageSrc) {
            var imageStyle = { transform: "translateY(-50%) translateX(-50%)" };

            return (
                <div className={"seat-info-views" + (this.props.seatViewImageSrc.length > 0 ? " has-img" : "") + (this.props.viewFromSeatModalActive ? " open" : "")} style={{ backgroundImage: "url(" + this.props.seatViewImageSrc + ")" }}>
                    <img className="seat-info-views-smallimage" alt="View from this seat." id="seatViewImg" style={imageStyle} src={this.props.seatViewImageSrc} />
                    <button className="seat-info-views-button plus" type="button" onClick={() => this._openSeatView()}>
                        <span className="visually-hidden">{this.props.altText.seatViewMagnifyingGlassSvg}</span>
                        <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagPlus }} />
                    </button>
                    <button className="seat-info-views-button minus" type="button" onClick={() => this._closeSeatView()}>
                        {/*TODO: hardcoded text*/}
                        <span className="visually-hidden">Close</span>
                        <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagMinus }} />
                    </button>
                    <button className="seat-info-views-button close" type="button" onClick={() => this._closeSeatView()}>
                        {/*TODO: hardcoded text*/}
                        <span className="visually-hidden">Close</span>
                        <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagClose }} />
                    </button>
                    <div className="seat-info-views-caption">
                        <p className="caption-paragraph">{this.props.seatViewCaptionText}</p>
                    </div>

                    <div className="seat-info-views-largeimage">
                        <div className="seat-info-views-trigger" onClick={() => this._closeSeatView()}></div>
                        <div className="seat-info-views-largeimage-inner">
                            <img src={this.props.seatViewImageSrc} alt="View from this seat." id="seatViewImgLarge" style={imageStyle} />
                            <button className="seat-info-views-button plus" type="button" onClick={() => this._openSeatView()}>
                                <span className="visually-hidden">{this.props.altText.seatViewMagnifyingGlassSvg}</span>
                                <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagPlus }} />
                            </button>
                            <button className="seat-info-views-button minus" type="button" onClick={() => this._closeSeatView()}>
                                {/*TODO: hardcoded text*/}
                                <span className="visually-hidden">Close</span>
                                <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagMinus }} />
                            </button>
                            <button className="seat-info-views-button close" type="button" onClick={() => this._closeSeatView()}>
                                {/*TODO: hardcoded text*/}
                                <span className="visually-hidden">Close</span>
                                <svg className="seat-info-views-icon" dangerouslySetInnerHTML={{ __html: useTagClose }} />
                            </button>
                            <div className="seat-info-views-largeimage-inner-caption">
                                <p className="caption-paragraph">{this.props.seatViewCaptionText}</p>
                            </div>
                        </div>

                    </div>
                </div >
            );
        } else {
            return (
                <div>
                    {this.props.loadingSeatView ?
                        <div className="sidebar-loader">
                            <DataLoader {...this.props}
                                loadingSvgText={this.props.loadingSvgText}
                                loadingText={this.props.loadingText}
                                stopAnimationText={this.props.stopLoadingAnimationButtonText}
                            />
                        </div>
                        : null}
                </div>
            );
        }
    }



    _openSeatView() {
        this.props.dispatch(openViewFromSeatModal());
    }

    _closeSeatView() {
        this.props.dispatch(closeViewFromSeatModal());
    }

    _handleMotion(event) {

        if (this.props.viewFromSeatModalActive) {
            const seatViewImg = document.getElementById("seatViewImg");

            if (seatViewImg) {
                const minValue = 0;
                //const maxValue = (seatViewImg.getBoundingClientRect().width - window.innerWidth + (seatViewImg.getBoundingClientRect().width * .5)) / seatViewImg.getBoundingClientRect().width;
                const maxValue = 100;

                if (Math.abs(event.alpha) > 10) {
                    const newState = {
                        ...this.state,
                        phonePanned: true
                    };
                    this.setState(newState as any);
                    if (event.alpha < 0) {

                        if (seatViewImg.getBoundingClientRect().left <= 0) {
                            var transform = this.state.seatViewTransform + -event.alpha * .02;
                            const newState = {
                                ...this.state,
                                seatViewTransform: transform > minValue ? minValue : transform,
                                currentGamma: event.alpha
                            };
                            const newTransformX = transform > minValue ? minValue : transform;

                            if (this.seatViewImg == null) {
                                this.seatViewImg = document.getElementById("seatViewImg");
                            }
                            if (this.seatViewImgLarge == null) {
                                this.seatViewImgLarge = document.getElementById("seatViewImgLarge");
                            }
                            this.seatViewImg.setAttribute("style", "transform: translateY(-50%) translateX(" + newTransformX + "%)");
                            this.seatViewImgLarge.setAttribute("style", "transform: translateY(-50%) translateX(" + newTransformX + "%)");
                            this.setState(newState as any);
                        }
                    } else if (event.alpha > 0) {
                        if (seatViewImg.getBoundingClientRect().right >= window.innerWidth) {
                            var transform = this.state.seatViewTransform - event.alpha * .02;
                            const newState = {
                                ...this.state,
                                seatViewTransform: transform < (maxValue * -1) ? maxValue * -1 : transform,
                                currentGamma: event.alpha
                            };
                            const newTransformX = transform > minValue ? minValue : transform;
                            if (this.seatViewImg == null) {
                                this.seatViewImg = document.getElementById("seatViewImg");
                            }
                            if (this.seatViewImgLarge == null) {
                                this.seatViewImgLarge = document.getElementById("seatViewImgLarge");
                            }
                            this.seatViewImg.setAttribute("style", "transform: translateY(-50%) translateX(" + newTransformX + "%)");
                            this.seatViewImgLarge.setAttribute("style", "transform: translateY(-50%) translateX(" + newTransformX + "%)");

                            this.setState(newState as any);
                        }
                    }
                }

            }

        }

    }
}

export default SeatInfoImage;